import { toast } from "react-toastify";

export const isValidName = (val) => {
    if (val.length > 0) {
        let regUser = /^[A-Za-z0-9_]+$/;
        return regUser.test(val);
    }
    return true
}

export const isValidPath = (val) => {
    if (val.length > 0) {
        let regUser = /^[A-Za-z0-9_-]+$/;
        return regUser.test(val);
    }
    return true
}

export const isValidIpAddress = (val) => {
    let IpRegex = /^(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    return IpRegex.test(val);
}

export const parameterValidation = (type, obj) => {
    switch (type.toUpperCase()) {
        case "SIZE":
            const min = parseInt(obj.min);
            const max = ((obj.max === null) || (obj.max === "")) ? obj.max : parseInt(obj.max);
            if (min < 0 || min === null || min === undefined || min === "") {
                toast.error(`Please Provide Valid Minimum Value.`)
                return false;
            }

            if ((min > max) || (max < 0 && min > max) || (max === null) || (max === undefined) || (max === "") || (max === NaN)) {
                toast.error(`Please Provide Valid Maximum Value.`)
                return false;
            }
            return true;

        case "EMAIL":
            if (obj.regex === null || obj.regex === undefined || obj.regex === "" || obj.regex === 0) {
                toast.error(`Regex must not be Empty or Zero.`);
                return false;
            }
            return true;
        case "MAX":
            const maxValue = ((obj.max === null) || (obj.max === "")) ? obj.max : parseInt(obj.max);
            if (maxValue === null || maxValue === undefined || maxValue === "" || maxValue === 0) {
                toast.error(`Please Provide Valid Maximum Value.`)
                return false;
            }
            return true;

        case "DIGIT":
            const digit = parseInt(obj.integer), fractionVal = parseInt(obj.fraction)
            if (digit === null || digit === undefined || digit === "" || digit === 0) {
                toast.error(`Please Provide Valid Digit Value.`)
                return false;
            }

            if (fractionVal === null || fractionVal === undefined || fractionVal === "" || fractionVal === 0) {
                toast.error(`Please Provide Valid Fractional Value.`)
                return false;
            }
            return true;

        default:
            break;
    }
}